var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBought(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 18.125C6.94036 18.125 7.5 17.5654 7.5 16.875C7.5 16.1846 6.94036 15.625 6.25 15.625C5.55964 15.625 5 16.1846 5 16.875C5 17.5654 5.55964 18.125 6.25 18.125Z",
    fill: "#52CC8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 18.125C15.0654 18.125 15.625 17.5654 15.625 16.875C15.625 16.1846 15.0654 15.625 14.375 15.625C13.6846 15.625 13.125 16.1846 13.125 16.875C13.125 17.5654 13.6846 18.125 14.375 18.125Z",
    fill: "#52CC8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30469 5.625H5.14708M0.625 2.5H1.9375C2.0734 2.49986 2.20565 2.54401 2.3142 2.62578C2.42275 2.70754 2.50169 2.82246 2.53906 2.95313L5.36719 12.8438C5.44078 13.1057 5.59836 13.3363 5.81572 13.5C6.03308 13.6638 6.29819 13.7516 6.57031 13.75H14.0547C14.3268 13.7516 14.5919 13.6638 14.8093 13.5C15.0266 13.3363 15.1842 13.1057 15.2578 12.8438L15.5156 11.9414L15.6445 11.4902",
    stroke: "#52CC8A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20605 9.71663V5.646L9.38516 9.71663V5.646M13.2263 5.646H11.3905V7.68131M11.3905 9.71663V7.68131M11.3905 7.68131H13.0669M15.0165 5.646H16.1311M16.1311 5.646H17.2244M16.1311 5.646V9.71663",
    stroke: "#52CC8A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBought);
export default __webpack_public_path__ + "static/media/bought.877d8e835462879b2191b8fff7256dcd.svg";
export { ForwardRef as ReactComponent };